import { useState } from "react";
import FAQAccordion from "@/components/FAQAccordion";
import { BookDemoModal, CapabilityModal } from "@/components/Modals";
import {
    useAnchorScroll,
    useReveal,
    useScrolledPast,
} from "@/components/utils";

import Nav, { NAV_ITEMS } from "@/components/Landing/Nav";
import StickyCTA from "@/components/Landing/StickyCTA";
import Hero from "@/components/Landing/sections/Hero";
import Problem from "@/components/Landing/sections/Problem";
import Solution from "@/components/Landing/sections/Solution";
import Modules from "@/components/Landing/sections/Modules";
import Why from "@/components/Landing/sections/Why";
import HowItWorks from "@/components/Landing/sections/HowItWorks";
import CustomerProof from "@/components/Landing/sections/CustomerProof";
import Security from "@/components/Landing/sections/Security";
import Pricing from "@/components/Landing/sections/Pricing";
import FAQSection from "@/components/Landing/sections/FAQ";
import FinalCTA from "@/components/Landing/sections/FinalCTA";
import Footer from "@/components/Landing/sections/Footer";

/**
 * Edara Software landing page — top-level composition.
 * Each section is its own component under /Landing/sections.
 */
export default function Landing() {
    const [bookOpen, setBookOpen] = useState(false);
    const [capabilityOpen, setCapabilityOpen] = useState(false);
    const scrolledPast = useScrolledPast(700);
    const scrollTo = useAnchorScroll(72);
    useReveal();

    const openBook = () => setBookOpen(true);
    const openCapability = () => setCapabilityOpen(true);

    return (
        <div className="bg-[#0A0A0A] text-white selection:bg-[#1FA8FF]/40">
            <a className="skip-link" href="#main">
                Skip to main content
            </a>

            <Nav
                navItems={NAV_ITEMS}
                scrolledPast={scrolledPast}
                scrollTo={scrollTo}
                onBook={openBook}
                onCapability={openCapability}
            />

            <main id="main">
                <Hero onBook={openBook} onCapability={openCapability} />
                <Problem />
                <Solution />
                <Modules onBook={openBook} />
                <Why />
                <HowItWorks />
                <CustomerProof />
                <Security onCapability={openCapability} />
                <Pricing onBook={openBook} />
                <FAQSection>
                    <FAQAccordion />
                </FAQSection>
                <FinalCTA onBook={openBook} />
                <Footer onBook={openBook} scrollTo={scrollTo} />
            </main>

            <StickyCTA visible={scrolledPast} onBook={openBook} />

            <BookDemoModal
                open={bookOpen}
                onClose={() => setBookOpen(false)}
            />
            <CapabilityModal
                open={capabilityOpen}
                onClose={() => setCapabilityOpen(false)}
            />
        </div>
    );
}
